/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';

import { UserIdleModule } from 'angular-user-idle';

import { OrderModule } from 'ngx-order-pipe';

import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpRequest, HttpHandler, HttpInterceptor, HttpEvent } from '@angular/common/http';
import { StorageModule } from '@ngx-pwa/local-storage';


export class AddHttpHeaderInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let clonedReq = req;

    // console.log(req.url);
    if (req.url.includes('api/public')) {
      clonedReq = req.clone({
        headers: req.headers
          .set('Bludot-Api-Key', environment.apis.BludotApiKey)
      });
    }
    return next.handle(clonedReq);

  }
}



@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    OrderModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ThemeModule.forRoot(),
    // UserIdleModule.forRoot({ idle: 60 * 10, timeout: 60 * 5, ping: 60 * 2 }),
    UserIdleModule.forRoot({ idle: 60 * 5, timeout: 1, ping: 60 * 2 }),

    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    StorageModule.forRoot({ IDBNoWrap: true }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddHttpHeaderInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
